module.exports = __webpack_public_path__ + "img/cable-gray.3832b890.svg";